export enum ProgressState {
  Completed,
  InProgress,
  Processing,
  Pending
}
